import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { RoleStr } from '../Commons/Utils'

class DemandItem extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.item._id !== this.props.item._id
    }

    render() {
        // 날짜 변환
        const newDate = new Date(this.props.item.createdAt)
        const newYear = newDate.getFullYear()

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }

        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }

        let status = ''
        if (this.props.item.status === 'READY') {
            status = 'status_b'
        } else if (this.props.item.status === 'HOLD') {
            status = 'status_r'
        } else if (this.props.item.status === 'OPEN') {
            status = 'status_y'
        } else {
            status = 'status_g'
        }

        let assignee = ''
        if (this.props.item.assignee) {
            assignee = this.props.item.assignee.name
        } else {
            assignee = '지정안됨'
        }

        return (
            <Link to={`/demand/${this.props.item._id}`}>
                <ul className="demand_item">
                    <li className="title">
                        <p className="title_text">{this.props.item.title}</p>
                        <p className="reply_length">[{this.props.item.comments.length}]</p>
                    </li>
                    <li className="name pc_v_impo">
                        {/* TODO : JACK User의 Group 개념 제거 {RoleStr[this.props.item.assignee.group]} {this.props.item.assignee.name} */}
                        {assignee}
                    </li>
                    <li className="date">
                        {newYear}.{newMonth}.{newDay}
                        <span className={status + ' status mobile_v'}>{this.props.item.status}</span>
                    </li>
                    <li className={status + ' status pc_v_impo'}>{this.props.item.status}</li>
                </ul>
            </Link>
        )
    }
}

export default DemandItem



// WEBPACK FOOTER //
// ./Src/Components/Demand/DemandItem.js